<template>
  <div class="page-work-detail">
    <comment-bar-layout class="page-program-detail"
                        :show-bar="showBottomBar"
                        :placeholder="commentPlaceholder"
                        :comment.sync="commentContent"
                        :focus="commentFocus"
                        @comment="handleComment"
                        @page-click="handlePageClick"
    >
      <user-info v-if="user && work"
                 :user="user"
                 :cover="work.cover"
      />
      <work-info v-if="work"
                 :work="work"
                 :hidden-video="open"
      />
      <product-info v-if="product && work && work.joinStatus !== 'member'"
                    :product="product"
      />
      <work-tutor-review v-if="showTutorReview"
                         :tutor-review="tutorReview"
                         :show-more="render.showAllReviewContent"
                         :show-reply="!open"
      />
      <challenge-info v-if="challenge && work && work.joinStatus === 'member'"
                      :challenge="challenge"
      />
      <recommend-work v-if="recommend && recommend.list.length > 0"
                      :recommend-work-list="recommend.list"
                      :challenge-id="recommend.challenge.id"
      />
      <work-review-list v-if="reviews && work"
                        :reviews="reviews"
                        :work-id="work.id"
      />
    </comment-bar-layout>
  </div>
</template>

<script>
  import CommentBarLayout from '@/layout/CommentBarLayout';
  import validator from '@/utils/validator';
  import { createWorkComment } from '@/services/comment';
  import UserInfo from '@/pages/Work/components/UserInfo';
  import WorkInfo from '@/pages/Work/components/WorkInfo';
  import ChallengeInfo from '@/pages/Work/components/ChallengeInfo';
  import ProductInfo from '@/pages/Work/components/ProductInfo';
  import WorkTutorReview from '@/pages/Work/components/WorkTutorReview';
  import RecommendWork from '@/pages/Work/components/RecommendWork';
  import WorkReviewList from '@/pages/Work/components/WorkReviewList';
  import { getWorkDetail } from '@/services/work';
  import { getUID } from '@/utils/index';

  export default {
    name: 'PageWorkDetail',
    metaInfo: {
      title: '作品详情',
    },
    components: {
      CommentBarLayout,
      UserInfo,
      WorkInfo,
      ChallengeInfo,
      ProductInfo,
      WorkTutorReview,
      RecommendWork,
      WorkReviewList,
    },
    data() {
      return {
        showBottomBar: true,
        reviews: null,
        commentPlaceholder: '优质评论将会被优先展示哦~',
        commentReplyId: 0,
        commentContent: '',
        commentFocus: false,
        challenge: null,
        product: null,
        recommend: null,
        tutorReview: null,
        user: null,
        work: null,
        render: null,
        open: false,
      };
    },
    computed: {
      showTutorReview() {
        if (this.tutorReview && this.work) {
          return !!(this.open || this.work.joinStatus === 'member');
        }
        return false;
      },
    },
    methods: {
      async fetchData(id) {
        const data = await getWorkDetail(id);
        this.challenge = data.challenge;
        this.reviews = data.reviews;
        this.product = data.product;
        this.tutorReview = data.tutorReview;
        this.user = data.user;
        this.work = data.work;
        this.render = data.render;
        this.recommend = data.recommend;
      },
      resetComment() {
        this.commentContent = '';
        this.commentReplyId = 0;
      },
      handlePageClick() {
        if (this.commentReplyId > 0) {
          this.commentPlaceholder = '优质评论将会被优先展示哦~';
          this.resetComment();
        }
      },
      handleClickReply(review) {
        if (review.type === 'quote') return;
        if (review.id === 0) {
          this.$toast('找不到正确的评论');
          return;
        }
        const userId = getUID();
        if (parseInt(userId, 10) === parseInt(review.userId, 10)) {
          this.$toast('不可以回复自己的评论哦');
          return;
        }
        this.commentPlaceholder = `回复：${review.name}`;
        this.commentReplyId = review.id;
        this.commentFocus = true;
      },
      async handleComment(content) {
        if (validator.isEmpty(content)) {
          this.$toast('请输入内容');
          return;
        }
        const data = await createWorkComment({
          workId: this.work.id,
          content,
          replyId: this.commentReplyId,
        });
        this.reviews.list = [data, ...this.reviews.list];
        this.reviews.start = this.reviews.start + 1;
        this.reviews.count = this.reviews.count + 1;
        this.commentPlaceholder = '优质评论将会被优先展示哦~';
        this.resetComment();
      },
    },
    created() {
      this.open = Boolean(this.$route.query.open);
      this.fetchData(this.$route.params.id);
    },
    beforeRouteUpdate(to, from, next) {
      const { id } = to.params;
      this.fetchData(id);
      next();
    },
  };
</script>
